<template>
    <div>
        <zm-tabs v-model="type">
            <zm-tab-pane label="PRODUCER" name="PRODUCER">
                <clientparam type="PRODUCER"></clientparam>
            </zm-tab-pane>
            <zm-tab-pane label="CONSUMER" name="CONSUMER">
                <clientparam type="CONSUMER"></clientparam>
            </zm-tab-pane>
        </zm-tabs>
    </div>
</template>
<script>
import clientparam from './clientparam'
export default {
    components: {
        clientparam
    },
    data () {
        return {
            type: 'PRODUCER'
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.type = JSON.parse(localStorage.params).type
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    watch: {
        type () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { type } = this
            const data = { path: this.$route.path, type }
            localStorage.params = JSON.stringify(data)
        }
    }
}
</script>
